import { getRequest } from '@/core';

export default async function getClerksRequest() {
	try {
		return await getRequest('/users');
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
